
export const processMarkdownHeaders = (content: string) => {
  if (!content) return { title: '', sections: [] };
  

  const parts = content.split(/(?=^#+\s)/m).filter(part => part.trim());
  
  const processedParts = parts.map(part => {

    return part.replace(/^#+\s+/, '').trim();
  }).filter(part => part !== ''); 
  
  if (processedParts.length === 0) {
    return { title: content, sections: [] };
  }
  
  const title = processedParts[0];
  const sections = processedParts.slice(1);
  
  return { title, sections };
};

export const processMessageContent = (content: string): string => {
  return content.replace(/^#+\s+/gm, '');
};

export const extractHeadingAndContent = (section: string) => {
  const lines = section.split('\n');
  const heading = lines[0].trim();
  
  if (!heading || /^#+$/.test(heading)) {
    const actualContent = lines.slice(1).join('\n').trim();
    return { heading: '', content: actualContent };
  }
  
  if (heading.includes(':')) {
    const [potentialHeading, ...rest] = heading.split(':');
    if (potentialHeading.length < 50) { 
      return { 
        heading: potentialHeading + ':', 
        content: [rest.join(':'), ...lines.slice(1)].join('\n').trim()
      };
    }
  }
  
  const content = lines.slice(1).join('\n').trim();
  return { heading, content };
};

